import "./EventPopoverModal.scss";
import { DsaScheduleEventDto } from "../../generated/dashboard-client";
import { PositionElement } from "../pages/DSASchedules";
import { ReactNode, useRef } from "react";
import { useOnClickOutside } from "usehooks-ts";
import moment from "moment";
import { CloseOutlined, DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { useRecoilValue } from "recoil";
import { mobileState } from "../../state/atoms";
import { Drawer } from "antd";
import { getCustomRecurLabel } from "./ManageScheduleModal";

export interface EventPopoverModalProps {
  event: DsaScheduleEventDto | null;
  title: string;
  eventStart: moment.Moment;
  eventEnd: moment.Moment;
  isVisible: boolean;
  position: PositionElement;
  onDeleteClick: () => void;
  onEditClick: () => void;
  onClose: () => void;
  withTooltip: (tooltip: string, object: ReactNode) => ReactNode;
}

export function EventPopoverModal({
  isVisible,
  event,
  title,
  eventStart,
  eventEnd,
  position,
  onDeleteClick,
  onEditClick,
  onClose,
  withTooltip,
}: EventPopoverModalProps) {
  const mobile = useRecoilValue(mobileState);
  
  const ref = useRef(null);
  const handleClickOutside = (ev: MouseEvent) => {
    if (isVisible) {
      onClose();
    }
  }
  useOnClickOutside(ref, (ev) => handleClickOutside(ev as MouseEvent));

  function eventRange(event: DsaScheduleEventDto) {
    if (!eventStart.format || !eventEnd.format) return;
    if (eventStart.format('MM DD YYYY') === eventEnd.format('MM DD YYYY')) {
      return <>{eventStart.format('MMM DD, YYYY')} &bull; {moment(eventStart, 'HH:mm').format('h:mmA')} - {moment(eventEnd, 'HH:mm').format('h:mmA')}</>;
    }
    return <>{eventStart.format('MMM DD YYYY')}, {moment(eventStart, 'HH:mm').format('h:mmA')} - {eventEnd.format('MMM DD YYYY')}, {moment(eventEnd, 'HH:mm').format('h:mmA')}</>;
  } 

  const content = <>
    <div className="actions">
      {withTooltip('Edit Event', <div className="edit action" onClick={() => onEditClick()}>
        <EditOutlined/>
      </div>)}
      {withTooltip('Delete Event', <div className="delete action" onClick={() => onDeleteClick()}>
        <DeleteOutlined/>
      </div>)}
      <div className="close action" onClick={() => onClose()}>
        <CloseOutlined/>
      </div>
    </div>
    {event && <div className="title">
      <div className="color" style={{backgroundColor: event.color}}/>
      <h3>{title}</h3>
    </div>}
    {event && <p>{eventRange(event)}</p>}
    {event && event.repeat && event.repeat !== 'no-repeat' && event.rrule && event.startDate &&
    <p>{getCustomRecurLabel(event.rrule, moment(event.startDate).format('YYYY-MM-DD'))}</p>}
  </>

  return (mobile ?
    <Drawer
      placement="bottom"
      visible={isVisible}
      className="mobile-bottom-menu event-popover-modal"
      maskClosable={true}
      closeIcon={false}
      height={175}
      onClose={() => onClose()}
    >
      {content}
    </Drawer>
    :
    <div
      ref={ref}
      className={"event-popover-modal"}
      style={{display: isVisible ? 'block' : 'none', top: Math.min(Math.max(position.y - 66, 0), document.body.scrollHeight - 160), left: Math.max(position.x - 370, 0), margin: 0}}
    >
      {content}
    </div>)
}
